import { createFileRoute } from "@tanstack/react-router";

import { AdjustmentsPage } from "../../../../features/inventory/adjustments-page";

export const Route = createFileRoute("/_app/inventory/adjustments/")({ component: AdjustmentsPage });
